module.exports = __webpack_public_path__ + "static/media/mateo-navarrete-resume-2023.39a6436f.pdf";